
// This file was auto-generated by generate-environment.js script.
export const environment = {
  production: false,
  apiGateway: 'https://z0hn6d5wc4.execute-api.us-east-1.amazonaws.com',
  operatingCompany: '9d08e8a0-3c80-4128-b19d-3e523ca53d11',
  oauthUrl: 'https://efleet-dev.auth.us-east-1.amazoncognito.com/login',
  oauthClientId: '1jn1ik1vab266o62geu1tea8u1',
  recaptchaKey: '6LdeBuIoAAAAADzdIqGUZaCtptXmHo_mdjYj9Aqu',
  mapStyleKey: 'dJ79rTjSVA6TuEokvMvI',
  chargersLocationKey: 'nN9tkZTuXcyYdHju4y6pDFe9yUi9fux9KeZ47gdA'
};
